import React from 'react';
import { Download, RefreshCw, X, Loader2, ArrowDownUp, FileText, Plus, Minus } from 'lucide-react';

const AppBarWithFilters = ({
  selectedSpider,
  spiderOptions,
  handleSpiderChange,
  handleExport,
  handleExportModal,
  handleTRAction,
  selectedRowsCount = 0,
  handleRunCommand,
  isRunning,
  handleCancel,
  showRunCommand = true,
  showAdvancedExport = true,
  showTRActions = true,
  children
}) => {
  return (
    <div className="rounded-lg border bg-card shadow-sm mb-4 overflow-hidden relative">
      {/* Barra de gradiente superior */}
      <div className="bg-gradient-to-r from-blue-500 to-indigo-500 h-2"></div>
      
      {/* Seção principal - Funcionalidades gerais */}
      <div className="p-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-grow">
          {/* Botões de Exportação */}
          <div className="flex items-center gap-2">
            {/* Botão Exportar Simples (mantém o original) */}
            <button 
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
              onClick={handleExport}
              title="Exportação rápida com campos padrão"
            >
              <Download className="mr-2 h-4 w-4" />
              Exportar TXT
            </button>
            
            {/* Botão Exportar Avançado (novo modal) */}
            {showAdvancedExport && handleExportModal && (
              <button 
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-orange-600 text-white hover:bg-orange-700 h-9 px-4 py-2"
                onClick={handleExportModal}
                title="Exportação avançada com seleção de campos"
              >
                <FileText className="mr-2 h-4 w-4" />
                Exportar Avançado
              </button>
            )}
          </div>

          {/* Separador visual */}
          <div className="h-6 w-px bg-gray-300"></div>

          {/* Botões de Ações TR */}
          {showTRActions && handleTRAction && (
            <div className="flex items-center gap-2">
              <button 
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-green-600 text-white hover:bg-green-700 h-9 px-4 py-2"
                onClick={() => handleTRAction('add')}
                disabled={selectedRowsCount === 0}
                title={selectedRowsCount === 0 ? "Selecione cupons para adicionar ao TR" : `Adicionar ${selectedRowsCount} cupom(s) ao TR`}
              >
                <Plus className="mr-2 h-4 w-4" />
                Adicionar ao TR
                {selectedRowsCount > 0 && (
                  <span className="ml-2 px-2 py-0.5 bg-green-500 text-green-100 rounded-full text-xs font-semibold">
                    {selectedRowsCount}
                  </span>
                )}
              </button>
              
              <button 
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-red-600 text-white hover:bg-red-700 h-9 px-4 py-2"
                onClick={() => handleTRAction('remove')}
                disabled={selectedRowsCount === 0}
                title={selectedRowsCount === 0 ? "Selecione cupons para remover do TR" : `Remover ${selectedRowsCount} cupom(s) do TR`}
              >
                <Minus className="mr-2 h-4 w-4" />
                Remover do TR
                {selectedRowsCount > 0 && (
                  <span className="ml-2 px-2 py-0.5 bg-red-500 text-red-100 rounded-full text-xs font-semibold">
                    {selectedRowsCount}
                  </span>
                )}
              </button>
            </div>
          )}
          
          {/* Seletor de Spider para filtrar a tabela */}
          <div className="inline-flex items-center">
            <div className="relative flex items-center">
              <ArrowDownUp className="absolute left-2.5 text-muted-foreground h-4 w-4" />
              <select
                value={selectedSpider}
                onChange={handleSpiderChange}
                className="rounded-md border border-input bg-background pl-8 pr-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring h-9"
              >
                <option value="">Filtrar por Spider</option>
                {spiderOptions.map((spider) => (
                  <option key={spider} value={spider}>
                    {spider}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        
        {/* Botões para executar/cancelar crawlers e componentes extras */}
        <div className="flex items-center gap-2">
          {showRunCommand && (
            <>
              <button 
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 py-2"
                onClick={handleRunCommand}
                disabled={isRunning}
              >
                {isRunning ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Carregando...
                  </>
                ) : (
                  <>
                    <RefreshCw className="mr-2 h-4 w-4" />
                    Atualizar Crawlers
                  </>
                )}
              </button>

              {isRunning && (
                <button 
                  className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-destructive text-destructive-foreground hover:bg-destructive/90 h-9 px-4 py-2"
                  onClick={handleCancel}
                >
                  <X className="mr-2 h-4 w-4" />
                  Cancelar
                </button>
              )}
            </>
          )}
          
          {/* Componentes extras (como ZyteSection, botões customizados, etc.) */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppBarWithFilters;